<template>
  <div class="dataForm" style="min-width:800px;">
    <el-form
    ref="dataForm"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    :disabled="formDisabled"
    >
      <div class="underlineForm">
        <el-form-item label="申请原因" prop="des" class="fullWidth">
          <el-input v-model="ruleForm.des" type="textarea" class="filter-item" clearable></el-input>
        </el-form-item>
        <div class="mb-20 fullWidth" v-if="mode !== 'approval'">
          <!-- <el-button @click="handleAddComand('purchaseAdvance')" type="primary" >
            添加预采购
          </el-button> -->
          <el-button @click="handleAddComand('material')" type="primary" >
            添加物料
          </el-button>
          <el-button @click="handleRemoveComand" >
            移除
          </el-button>
        </div>
        <el-table
          :data="ruleForm.details"
          border
          fit
          row-key="materialId"
          style="width: 100%"
          :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
          :span-method="objectSpanMethod"
          @selection-change="handleTableSelect"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column type="selection" width="55" fixed/>
          <el-table-column prop="amount" label="数量" fixed min-width="120">
            <template #default="{ row }">
              <el-input v-model="row.amount" type="number" :min="0" @input='handleCalcTotal'></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="locationId" label="仓库位置" fixed min-width="160">
            <template #default="{ row }">
              <el-select :filterable="true" v-model="row.locationId" class="filter-item" placeholder="输入关键字搜索" :size="t('table.btnSize')" @change="handleLocationChange($event, row)">
                <template v-if="row.locationOption?.length">
                  <el-option
                    v-for="item in row.locationOption"
                    :key="item.locationId"
                    :label="item.location?.location"
                    :value="item.locationId"
                  />
                </template>
                <el-option
                  v-else
                  :value="-1"
                  disabled
                  style="color:red"
                >
                  需要采购
                </el-option>
              </el-select>
            </template>
          </el-table-column>
           <el-table-column prop="materialAmount2" label="库存数量" min-width="100"/>
          <el-table-column prop="materialUsed" label="已使用数量" min-width="100"/>
          <el-table-column prop="materialNo" label="物料编号" min-width="160"/>
          <el-table-column prop="materialName" label="物料名称" min-width="100"/>
          <el-table-column prop="materialBrand" label="物料品牌" min-width="100"/>
          <el-table-column prop="materialModel" label="物料型号" min-width="100"/>
          <el-table-column prop="materialUnit" label="物料单位" min-width="100"/>
          <el-table-column prop="materialStandard" label="封装规格" />
        </el-table>
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmitPre"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      :title="addType === 'purchaseAdvance' ? '预采购列表' : '物料列表'"
      width="80%"
    >
      <PurchaseAdvanceList mode="table" ref="PurchaseAdvanceList" :excludeIds="getexcludeIds()" v-if="addType === 'purchaseAdvance'" :statusIn="0"/>
      <MaterialList ref="MaterialList" v-else :excludeIds="getexcludeIds()" :officeSupplies="type === 'OFFICE' ? true : false" pathApi="material"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="handleAdd"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref, computed } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'

import { ElMessage, ElForm, ElMessageBox } from 'element-plus'
import type { TableColumnCtx } from 'element-plus/es/components/table/src/table-column/defaults'
import { postUrl } from '@/apis/Dictionary'

import PurchaseAdvanceList from '@/views/purchasManage/purchaseInAdvance/PurchaseAdvanceDialog.vue'
import MaterialList from '@/views/purchasManage/materialInfo/MaterialDialog.vue'

import { useI18n } from 'vue-i18n'
import { orderBy } from 'lodash'
import $number from 'number-precision'
import { numberTimes } from '@/utils/index'
import $currency from 'currency.js'
import { maxMinCalc } from '@/views/purchasManage/materialInfo/FieldTable'

export default defineComponent({
  components: {
    PurchaseAdvanceList,
    MaterialList
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    handleResolveTempData: { type: Function, required: false },
    selectionArray: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    mode: { type: String, required: false, default: '' },
    type: { type: String, required: false, default: 'BUSINESS' }, // BUSINESS | OFFICE
    formDisabled: { type: Boolean, required: false, default: false },
    canSelectMaterial: { type: Boolean, required: false, default: true }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const PurchaseAdvanceList = ref({})
    const MaterialList = ref({})

    interface User {
      id: string;
      name: string;
      amount1: string;
      amount2: string;
      amount3: number;
    }
    interface SpanMethodProps {
      row: User;
      column: TableColumnCtx<User>;
      rowIndex: number;
      columnIndex: number;
    }

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      type: props.type,
      submitLoading: false,
      numberTimes,
      maxMinCalc,
      ruleForm: {
        des: '',
        businessId: null,
        details: []
      },
      rules: {
        des: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      dialogVisible: false,
      selectBusinessList: [],
      excludeIds: [],
      locationOption: [],
      addType: '',
      megreColumn: ['materialNo', 'materialName', 'materialBrand', 'materialModel', 'materialUnit', 'amount', 'fee', 'total'],
      locationOptionMap: new Map(),
      spanArrChange: computed(() => {
        const megre = ['materialNo']
        const data = dataMap.ruleForm.details
        const spanArr = {} as any
        megre.forEach((m: any) => {
          spanArr[m] = { spanArr: [], pos: 0 }
        })
        data.forEach((row, i) => {
          megre.forEach(m => {
            if (i === 0) {
              spanArr[m].spanArr.push(1)
              spanArr[m].pos = 0
            } else {
              if (row[m] === data[i - 1][m]) {
                spanArr[m].spanArr[spanArr[m].pos] += 1
                spanArr[m].spanArr.push(0)
              } else {
                spanArr[m].spanArr.push(1)
                spanArr[m].pos = i
              }
            }
          })
        })
        return spanArr
      }),

      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      getLocationOption(row: any) {
        getPageList(`storage/storage/${row.materialId}`).then((res: any) => {
          const locationOption = res?.filter((kk: any) => {
            return kk.amount > kk.used
          }) || []
          // dataMap.locationOptionMap.set(row.materialId, locationOption)
          row.locationOption = locationOption
          const firstItem = locationOption[0] || {}
          row.locationId = firstItem.locationId
          dataMap.handleLocationChange(firstItem.locationId, row)
        })
      },
      handleLocationChange(locationId: number, row: any) {
        const locationOption = row.locationOption
        const locationItem = locationOption.find((kk: any) => kk.locationId === locationId) || {}
        row.materialAmount2 = locationItem.amount || 0
        row.materialUsed = locationItem.used || 0
      },
      objectSpanMethod({ column, rowIndex }: SpanMethodProps) {
        if (column.type === 'selection' || dataMap.megreColumn.includes(column.property)) {
          return {
            rowspan: dataMap.spanArrChange.materialNo.spanArr[rowIndex],
            colspan: 1
          }
        } else {
          return { rowspan: 1, colspan: 1 }
        }
      },
      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['materialAmount', 'amount', 'total'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`

            sums[index] = ['total'].includes(column.property) ? $currency(sumNum).toString() : sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      },
      handleAddComand(addType: string) {
        dataMap.dialogVisible = true
        dataMap.addType = addType
      },
      getexcludeIds() {
        if (dataMap.addType === 'purchaseAdvance') {
          const temp = dataMap.ruleForm.details.map((k: any) => {
            return k.prePurchaseId
          })
          return temp.filter(Boolean)
        } else {
          return dataMap.ruleForm.details.map((k: any) => {
            return k.materialId
          })
        }
      },
      handleAdd(array: any) {
        let tempArray = [] as any
        if (array && array.length) {
          tempArray = array.map((kk: any) => {
            const existMaterial = dataMap.ruleForm.details.find((jj: any) => jj.materialId === kk.materialId)
            return existMaterial || kk
          })
        } else {
          if (dataMap.addType === 'purchaseAdvance') {
            tempArray = (PurchaseAdvanceList.value as any).selectionArray
          } else {
            tempArray = (MaterialList.value as any).selectionArray
          }
        }
        let materialIdIs = [] as any
        // const materialMap = new Map()
        tempArray = tempArray.map((item: any) => {
          let tempObj = {} as any
          if (dataMap.addType === 'material') {
            tempObj = {
              material: {
                ...item
              },
              materialNo: item.no,
              materialClass: item.materialClass,
              materialUnit: item.materialUnit,
              materialId: item.id,
              materialBrand: item.brand,
              materialName: item.name,
              materialModel: item.model,
              materialCode: item.code,
              materialParameter: item.parameter,
              materialDevice: item.device,
              addType: dataMap.addType,
              materialAmount: 0,
              amount: item.amount || 0,
              total: 0,
              locationId: item.locationId || null,
              materialAmount2: 0,
              materialUsed: 0,
              locationOption: [] as any
            }
          } else {
            tempObj = {
              ...item,
              prePurchaseId: item.id,
              addType: dataMap.addType,
              materialCreateUser: item.createUser,
              materialAmount: item.amount,
              amount: item.amount || 0,
              total: 0,
              materialAmount2: 0,
              materialUsed: 0,
              locationOption: [] as any
            }
          }

          materialIdIs.push(tempObj.materialId)
          return tempObj
        })

        tempArray = orderBy(dataMap.ruleForm.details.concat(tempArray), ['materialNo'], ['asc'])

        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          return {
            ...item,
            amount: item.amount || 0,
            locationId: item.locationId || null
          }
        })
        dataMap.ruleForm.details.forEach((kk: any) => {
          materialIdIs = Array.from(new Set(materialIdIs))
          if (materialIdIs.includes(kk.materialId)) {
            if (!kk.locationOption?.length) {
              dataMap.getLocationOption(kk)
            } else {
              const firstItem = kk.locationOption[0] || {}
              kk.locationId = firstItem.locationId
              dataMap.handleLocationChange(firstItem.locationId, kk)
            }
          }
        })
        dataMap.dialogVisible = false
      },
      handleRemoveComand() {
        if (!dataMap.selectBusinessList.length) {
          return ElMessage.error('请选择需要移除的数据！')
        }

        dataMap.selectBusinessList.forEach((item: any) => {
          dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => item.materialId !== k.materialId)
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmitPre() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const details = dataMap.ruleForm.details
              if (!details.length) {
                return ElMessage.error('请添加材料！')
              }

              // 校验物料类别
              const hasOffice = details.some((item: any) => item.materialClass && item.materialClass.includes('办公'))
              const allOffice = details.every((item: any) => item.materialClass && item.materialClass.includes('办公'))

              if (dataMap.type === 'BUSINESS' && hasOffice) {
                return ElMessage.error('业务/维修领料禁止包含办公用品！')
              }
              if (dataMap.type === 'OFFICE' && !allOffice) {
                return ElMessage.error('办公用品申请只能包含办公类物料！')
              }

              const tempArr = [] as any
              details.forEach((item: any) => {
                const tempObj = tempArr.find((k: any) => k.materialId === item.materialId) || {}
                if (!Object.keys(tempObj).length) {
                  tempArr.push({
                    materialId: item.materialId * 1,
                    num: item.amount ? item.amount * 1 : 0,
                    locationId: item.locationId,
                    materialAmount2: item.materialAmount2,
                    materialUsed: item.materialUsed
                  })
                } else {
                  if (item.prePurchaseId) {
                    tempObj.prePurchaseIds.push(item.prePurchaseId)
                  }
                }
              })
              for (let i = 0; i < tempArr.length; i++) {
                const item = tempArr[i]
                if (!item.num) {
                  return ElMessage.error('数量不得为0！')
                }
                if (item.num > (item.materialAmount2 * 1 - item.materialUsed * 1) || !item.locationId) {
                  return ElMessageBox.confirm('库存不足，将自动生成预采购单！').then(() => {
                    dataMap.handleSubmit(dataMap.ruleForm, tempArr)
                  })
                }
              }
              dataMap.handleSubmit(dataMap.ruleForm, tempArr)
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      async handleSubmit(tempData: any, tempArr: any) {
        try {
          await postUrl('storage/createMaterialDelivery', { ...tempData, businessId: props.id || null, details: tempArr })
          // if (response.hasPurchase) {
          //   ElMessage.info('库存不足，将自动生成预采购单！')
          // } else {
          ElMessage({
            message: '出库成功',
            type: 'success',
            duration: 2000
          })
          // }
          dataMap.submitLoading = false
          context.emit('update:visibel')
          context.emit('submit')
        } catch (err:any) {
          console.log(err, 'err')
          dataMap.submitLoading = false
          if (err && err.errors) {
            err.errors.forEach((item: any) => {
              const field = dataMap.rules[item.field][0]
              if (field) {
                field.message = null
                nextTick(() => {
                  field.message = item.defaultMessage
                })
              }
            })
          }
        }
      },
      handleCalcTotal() {
        dataMap.ruleForm.details = dataMap.ruleForm.details.map((item: any) => {
          return {
            ...item,
            total: numberTimes(item.fee || 0, item.amount, false)
          }
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      }
    })

    onMounted(() => {
      dataMap.clearValidate()
    })
    return { t, ...toRefs(dataMap), dataForm, MaterialList }
  }
})
</script>
<style lang="scss">
  .el-table .el-table__cell.is-hidden>*{
    visibility:visible
  }
</style>
